export { default } from './part-get-cashback';
